/**
 * CSV export with UTF-8 encoding and BOM so Excel and other tools display Lao/Unicode correctly.
 */

/** Escape a cell for CSV (quotes if contains comma, quote, or newline). */
export function escapeCsvCell(value: string): string {
  const s = String(value ?? "");
  if (s.includes('"') || s.includes(",") || s.includes("\n") || s.includes("\r")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * Trigger download of a CSV string as a file with UTF-8 encoding.
 * Uses BOM (U+FEFF) so Excel and similar apps recognize UTF-8 and display Lao/Unicode correctly.
 */
export function downloadCsvUtf8(csvContent: string, filename: string): void {
  const bom = "\uFEFF";
  const blob = new Blob([bom + csvContent], {
    type: "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
